appSocial.service('SocialUtils', [
    'moment', 'md5', '$state', '$ionicHistory', '$ionicViewSwitcher',
    function (moment, md5, $state, $ionicHistory, $ionicViewSwitcher) {
        class SocialUtils {
            createQuery(filter) {
                const query = filter.fields
                    .map(field => `${field.name}[${field.op}]=${field.value}::${field.next}::`)
                    .join('')
                    .replace(/(::\w+::)$/, '');

                const order = filter.order
                    .map(field => `${field.name}=${field.dir}`)
                    .join(',');

                let params = {
                    query: query,
                    order_by: order,
                    limit: filter.limit,
                    page: filter.page,
                };

                if (filter.dateRange) {
                    params = _.merge(params, {date_range: filter.dateRange})
                }
                return params;
            };

            dateTagToRange(tag) {
                switch (tag) {
                    case 'currentMonth':
                        return [
                            moment().startOf('month').unix(),
                            moment().unix(),
                        ];
                    case 'lastMonth':
                        return [
                            moment().startOf('month').subtract(1, 'month').unix(),
                            moment().startOf('month').unix()
                        ];
                    case 'lastTwoMonth':
                        return [
                            moment().startOf('month').subtract(2, 'month').unix(),
                            moment().startOf('month').unix()
                        ];
                    case 'lastThreeMonth':
                        return [
                            moment().startOf('month').subtract(3, 'month').unix(),
                            moment().startOf('month').unix()
                        ];
                    case 'lastSixMonth':
                        return [
                            moment().startOf('month').subtract(6, 'month').unix(),
                            moment().startOf('month').unix()
                        ];
                    case 'thisYear':
                        return [
                            moment().startOf('year').unix(),
                            moment().unix(),
                        ];
                    case 'thisTwoYears':
                        return [
                            moment().startOf('year').subtract(1, 'year').unix(),
                            moment().unix(),
                        ];
                    default:
                        return [
                            moment().startOf('year').subtract(10, 'year').unix(),
                            moment().unix(),
                        ];
                }
            };

            getParams(url) {
                const getParams = (url || location.search)
                    .replace(/\?/gi, '')
                    .replace(/\/$/, '')
                    .split('&')
                    .filter(item => item.length > 0);

                return getParams.reduce((acc, cur) => {
                    const [key, val] = cur.split('=');
                    acc[key] = val;
                    return acc;
                }, {});
            };

            getHash() {
                return md5.createHash((Math.random() * 999999).toString()).toString();
            }

            hashToNum(origin, base) {
                return origin.split('').reduce((accum, char) => accum + char.charCodeAt(0), 0)
                    % (typeof base !== 'undefined' ? base : Infinity);
            }

            camelCaseToDashes(camelCaseValue, dash = '_') {
                return camelCaseValue && camelCaseValue.replace(/([a-z0-9])([A-Z])/g, '$1' + dash + '$2') || '';
            }

            dashesToSpace(dashedValue) {
                return dashedValue && dashedValue.replace(/(_)/g, ' ') || '';
            }

            capitalizeFirstLetterOnly(value, lowerCaseOther = false) {
                return value && value.length && ((lowerCaseOther ? value.toLocaleLowerCase() : value)[0].toUpperCase() + value.slice(1)) || '';
            }

            navigate(state, params, disableAnimation = false) {
                const INITIAL_STATE = 'root.app.social';
                const NO_BACK_STATES = [
                    'root.app.socialRegistration'
                ];


                if (disableAnimation) {
                    $ionicHistory.nextViewOptions({disableAnimate: true});
                }

                if (state === 'back') {
                    // if no back view - go to initial page
                    if (!$ionicHistory.backView()
                        || NO_BACK_STATES.includes($ionicHistory.backView().stateName)) {
                        // console.log('[][][] No back view');
                        // TODO - pass this as a parameter
                        return $state.go(INITIAL_STATE);
                    }
                    // console.log('[][][] Back view is', $ionicHistory.backView().stateName);
                    return $ionicHistory.goBack();
                }

                // set next view animation as back
                if (params && params.direction === 'back') {
                    $ionicViewSwitcher.nextDirection('back')
                }

                return $state.go(state, params);
            }

            clearHistory() {
                $ionicHistory.clearHistory();
            }

            renderTranslation(message, values = {}) {
                return Object.keys(values).reduce((acc, cur) => {
                    const re = new RegExp('\%' + cur + '\%');
                    return acc.replace(re, values[cur]);
                }, message)
            }

            getRisk(score) {
                if (score <= 3) {
                    return 'low';
                }
                if (score > 3 && score <= 6) {
                    return 'medium';
                }
                if (score > 6) {
                    return 'high';
                }
            }
        }

        return new SocialUtils();
    }]);
